export type CellBox = { x: number; y: number; left: number; top: number; right: number; bottom: number };
export type Box = { left: number; top: number; right: number; bottom: number };

export function toCellBox(
  x: number,
  y: number,
  rect: Box & { x?: number; y?: number },
): CellBox {
  return { x, y, left: rect.left, top: rect.top, right: rect.right, bottom: rect.bottom };
}
export type DropHover = { kind: "cell"; x: number; y: number } | { kind: "trash" } | null;

export function pointInBox(box: Box, clientX: number, clientY: number): boolean {
  return clientX >= box.left && clientX < box.right && clientY >= box.top && clientY < box.bottom;
}

export function cellFromPoint(cells: readonly CellBox[], clientX: number, clientY: number): { x: number; y: number } | null {
  const hit = cells.find((cell) => pointInBox(cell, clientX, clientY));
  return hit ? { x: hit.x, y: hit.y } : null;
}

function nearestCell(cells: readonly CellBox[], clientX: number, clientY: number): { x: number; y: number } | null {
  if (cells.length === 0) return null;
  let best = cells[0];
  let bestDist = Number.POSITIVE_INFINITY;
  for (const cell of cells) {
    const cx = (cell.left + cell.right) / 2;
    const cy = (cell.top + cell.bottom) / 2;
    const dist = (clientX - cx) ** 2 + (clientY - cy) ** 2;
    if (dist < bestDist) {
      best = cell;
      bestDist = dist;
    }
  }
  return { x: best.x, y: best.y };
}

export function hoverFromPoint(
  cells: readonly CellBox[],
  trash: Box | null,
  clientX: number,
  clientY: number,
  gridBox?: Box | null,
): DropHover {
  if (trash && pointInBox(trash, clientX, clientY)) return { kind: "trash" };
  const cell = cellFromPoint(cells, clientX, clientY);
  if (cell) return { kind: "cell", ...cell };
  if (gridBox && pointInBox(gridBox, clientX, clientY)) {
    const near = nearestCell(cells, clientX, clientY);
    return near ? { kind: "cell", ...near } : null;
  }
  return null;
}
